import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';
import PurchaseOrder from './PurchaseOrder';
import OrderFields from './OrderFields'
import OrderFields2 from './OrderFields2'
import JobOrder from './JobOrder'




class OrderTab extends Component {

    constructor(){
        super();
        this.addFields = this.addFields.bind(this);
        this.remove = this.remove.bind(this)
        this.setData = this.setData.bind(this)
        this.addFields2 = this.addFields2.bind(this);
        this.remove2 = this.remove2.bind(this)
        this.setData2 = this.setData2.bind(this)
        this.setQuoteNumber = this.setQuoteNumber.bind(this)
        
        this.state = {
            fieldList : [],
            fieldList2 : [],            
            data : {},
            data2 : {},            
            quotation : {},
            inventoryListProduct:{},
            inventoryListSheet : {},
            userId:"",
            quoteNumber :""
        }
        
        
    }
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        }); 

        let quotation = ref.child("Quotation").orderByChild("status").equalTo("Deal");
            quotation.on("value", function(snap){
                this.setState({
                    quotation : snap.val()
                })
            }.bind(this))
            
         var listProduct = ref.child("Inventory").child("Products")
            listProduct.on("value", function(snap){
                this.setState({
                    inventoryListProduct : snap.val()
                })
            }.bind(this))

        var listSheet = ref.child("Inventory").child("Sheets")
            listSheet.on("value", function(snap){
                this.setState({
                    inventoryListSheet : snap.val()
                })
            }.bind(this))
    }

    
   

    addFields(){
        let fieldList = this.state.fieldList;        
        let index = Date.now();
        let count = fieldList.length
        this.setState({
            fieldList : fieldList.concat(<OrderFields  key={index}  index={index} count={count} remove={this.remove} setData = {this.setData}/>)
        })
        //console.log(this.state.inputList)
        // console.log(this.state.fieldList)
    }
    addFields2(){
        let fieldList2 = this.state.fieldList2;        
        let index = Date.now();
        let count = fieldList2.length
        this.setState({
            fieldList2 : fieldList2.concat(<OrderFields2  key={index}  index={index} count={count} remove2={this.remove2} setData2 = {this.setData2}/>)
        })
        //console.log(this.state.inputList)
        // console.log(this.state.fieldList)
    }
    
    remove(count,index){
        let fieldList = this.state.fieldList           
        delete fieldList[count]
        this.setState({fieldList})
        //console.log(this.state.fieldList)
        let data = this.state.data
        delete data[index]
        this.setState({
            data
        })
       
    }

    remove2(count,index){
        let fieldList2 = this.state.fieldList2          
        delete fieldList2[count]
        this.setState({fieldList2})
        //console.log(this.state.fieldList)
        let data2 = this.state.data2
        delete data2[index]
        this.setState({
            data2
        })
        
    }

    setData(total,index,length,number){
        let data = {...this.state.data}
            data[index] = {
                total : total,
                length : length,
                number : number
        }

        this.setState({
            data
        })
    }

    setData2(number,thickness,dimension,length,color,index){
        let data2 = {...this.state.data2}
            data2[index] = {
                number : number,
                thickness : thickness,
                dimension : dimension,
                length : length,
                color : color
        }

        this.setState({
            data2
        })
    }

    setQuoteNumber(quoteNumber){
        this.setState({
            quoteNumber : quoteNumber 
        })
    }

    


    render() {
            
        return (
            <div id="page-wrapper">
                
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar/>
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Purchase Order" />
                            <div className="block">                                
                                <div className="row"> 
                                    
                                </div>
                                {/*<!-- Working Tabs Block -->*/}
                                <div >
                                    {/*<!-- Working Tabs Content -->*/}
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/*<!-- Block Tabs -->*/}
                                            <div >
                                                {/*<!-- Block Tabs Title -->*/}
                                                <div className="block-title">
                                                    <ul className="nav nav-tabs" data-toggle="tabs">
                                                        <li className="active"><a href="#example-tabs2-activity">Purchase Order</a></li>
                                                        <li><a href="#example-tabs2-profile">Job Order</a></li>
                                                        
                                                    </ul>
                                                </div>
                                                {/*<!-- END Block Tabs Title -->*/}

                                                {/*<!-- Tabs Content -->*/}
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="example-tabs2-activity">
                                                        {/**********<!-- Purchase Order -->**********/}
                                                        <PurchaseOrder fieldList = {this.state.fieldList} data={this.state.data}  addFields={this.addFields} 
                                                        addFields2 = {this.addFields2} fieldList2 = {this.state.fieldList2} 
                                                        data2={this.state.data2} quotation={this.state.quotation} 
                                                        inventoryListProduct={this.state.inventoryListProduct} setQuoteNumber={this.setQuoteNumber}/>
                                                                                                                
                                                    </div>
                                                    <div className="tab-pane" id="example-tabs2-profile">
                                                        {/**********<!-- Job Order -->**********/}
                                                        <JobOrder userId ={this.state.userId} quoteNumber={this.state.quoteNumber}/>
                                                    </div>
                                                </div>
                                                {/*<!-- END Tabs Content -->*/}
                                            </div>
                                            {/*<!-- END Block Tabs -->*/}
                                        </div>
                                    </div>
                                    {/*<!-- END Working Tabs Content -->*/}
                                </div>
                                {/*<!-- Working Tabs Block -->*/}
                             
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderTab;



// WEBPACK FOOTER //
// ./src/components/OrderTab.js